export default __webpack_public_path__ + "static/media/0f1c7dee546e44b662021779ba5f2732.png";